<template>
    <div id="mask" v-show="show">
        <div id="box" class="window-scale">
            <div id="contain">
                <span id="tip">此處無題目</span>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: "LessonExamTip",
    data: function () {
        return {
            show: false,
        }
    },
    methods: {
        showTip() {
            const self = this;

            this.show = true;

            setTimeout(function () {
                self.show = false
            }, 2000)
        }
    }
}
</script>

<style scoped>
#mask {
    z-index: var(--z-index-lesson-exam);
    position: absolute;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.5);
}

#box {
    position: absolute;
    left: 50%;
    top: 50%;
}

#contain {
    position: absolute;
    transform: translate(-50%, -50%);
    left: 50%;
    top: 50%;
    width: 370px;
    height: 240px;
    border-radius: 5px;
    background-color: rgb(255, 255, 255);
    border-style: solid;
    border-color: rgb(28, 106, 188);
    border-width: 5px;
}

#tip {
    position: absolute;
    transform: translate(-50%, -50%);
    font-size: 20px;
    font-weight: bold;
    line-height: 1em;
    color: black;
    top: 50%;
    left: 50%;
}
</style>